import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as  R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { orders } from '../../../../../../redux/orders/action';
import ShipmentComponent from '../components/shipment.component';
import { selectTransportersListItems } from '../../../../../../redux/transporters/selector';
import { agents } from '../../../../../../redux/agents/action';
import { selectOrdersQueryItems } from '../../../../../../redux/orders/selector';
import { selectAgentsListItems } from '../../../../../../redux/agents/selector';
import PageLoader from '../../../../../../components/PageLoader';
import { onMessage } from 'firebase/messaging';
import { messaging } from '../../../../../../service/firebase';
import { transporters } from '../../../../../../redux/transporters/action';
import { selectListItems } from '../../../../../../redux/library/selector';


const CustomerOrder = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const libraryData = useSelector(selectListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const orderQuery = useSelector(selectOrdersQueryItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [location, setLocation] = useState<any>([])
  const [payload, setPayload] = useState<any>([{ notification: { title: '', body: '' } }])

  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    selectShipping,
    setSelectShipping
  ] = useState<any>([])


  const fetchorderById = () => {
    dispatch(orders.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/query`, entity: 'orders', jsonData: {

        Records: [
          {

            Id: parmas?.id
          }

        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }
  const handleInnerFormChange = (event: any, field: string) => {
    setSelectShipping({ ...selectShipping, [field]: event });
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      { field: 'VehicleBrand', headerName: 'Vehicle Brand' },
      { field: 'VehicleChasisnumber', headerName: 'Vehicle Chasis Number' },
      { field: 'VehicleModel', headerName: 'Vehicle Model' },
      { field: 'VehicleNumber', headerName: 'Vehicle Number' },
      { field: 'VehicleYear', headerName: 'Vehicle Year' },
    ]);
  }


  useEffect(
    () => {

      dispatch(agents.list({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/agents/list`, entity: 'agents', jsonData: {

        }
      }))
        .then(() => {
          if (parmas?.id > 0) {
            createColumnDefs()
            fetchorderById()
            setIsLoading(false)
          } else {
            setIsLoading(false)
          }
        })
      new Promise((resolve) => onMessage(messaging, (payload: any) => {
        const latLongData = _.split(payload?.data?.Location, ',');
        console.log(latLongData, 'latLongDatapayload')
        setPayload({ notification: { title: '', body: payload?.data?.Location } })
        console.log(payload, 'payload')
        setLocation(
          {
            Latitude: latLongData[0],
            Longitude: latLongData[1]
          }

        )
        resolve(payload)
      }))
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectShipping(orderQuery?.result?.items)
      }
    },
    [isQuery]
  )


  const back = () => {
    navigate('/customer/sales/orders')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ShipmentComponent
          rowData={selectShipping.MobilityOrderItems}
          columnDefs={columnDefs}
          orderStatus={libraryData?.result?.OrderStatus}
          selectShipping={selectShipping}
          handleInnerFormChange={handleInnerFormChange}
          transportAgents={transportAgentListItems.result.items}
          back={back}
          location={location}
        />}
    </>
  )

}

export default CustomerOrder;